import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 7 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 11\" id=\"arrow-left\">\n    <path fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.88.837L.9 5.371l4.98 4.474.65-.6L2.219 5.37l4.31-3.933z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol